import React, { useState } from "react";
import { NavLink, Route } from "react-router-dom";
import { IoChevronForwardOutline } from "react-icons/io5";

import {
  FiGrid,
  FiUser,
  FiUsers,
  FiTruck,
  FiUserPlus,
  FiSend,
} from "react-icons/fi"; // Import necessary icons

import { FaIndianRupeeSign } from "react-icons/fa6";

const SidebarSubMenu = ({ route, isSidebarClosed }) => {
  const [open, setOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState({});

  const handleSubMenu = () => {
    setOpen(isSidebarClosed ? false : (prevOpen) => !prevOpen);
  };
  const handleNestedSubMenu = (index) => {
    setSubMenuOpen((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const FiIcons = {
    FiGrid,
    FiUser,
    FiUsers,
    FiTruck,
    FiUserPlus,
    FiSend,
    FaIndianRupeeSign,
  };

  return (
    <>
      <li key={route.name}>
        <button
          className="pl-5 py-4 inline-flex items-center justify-between focus:outline-none w-full text-sm font-semibold transition-colors duration-150 dark:text-gray-200 hover:text-green-600 dark:hover:text-gray-200 text-nowrap"
          onClick={handleSubMenu}
          aria-haspopup="true"
        >
          <span className="inline-flex items-center">
            {route.icon && FiIcons[route.icon] ? (
              React.createElement(FiIcons[route.icon], {
                className: "w-5 h-5",
              })
            ) : (
              <></>
            )}
            {isSidebarClosed ? (
              ""
            ) : (
              <span className="mt-1 ml-4 text-nowrap">
                {/* {t(`${route.name}`)} */}
                {route.name}
              </span>
            )}
          </span>

          <span className="pr-3">
            {isSidebarClosed ? (
              ""
            ) : (
              <IoChevronForwardOutline
                className={`transform duration-200 ${open ? "rotate-90" : ""}`}
              />
            )}
          </span>
        </button>
        <ul
          className={`overflow-hidden text-sm font-medium text-gray-500 dark:text-gray-400 dark:bg-gray-800 bg-white sub-menu ${
            open ? "block" : "hidden"
          } ${open && isSidebarClosed ? "shadow-xl" : ""}`}
          aria-label="submenu"
        >
          {route.route &&
            route.route.length > 0 &&
            route.route.map((child, i) => (
              <li
                key={i + 1}
                className="dark:hover:bg-gray-600 dark:hover:text-gray-200 hover:bg-gray-300 py-1"
              >
                {child.route && child.route.length > 0 ? (
                  <button
                    className={`${
                      isSidebarClosed ? "" : "pl-4"
                    } py-1 inline-flex items-center justify-between focus:outline-none w-full text-sm transition-colors duration-150 hover:text-green-600 dark:hover:text-gray-100`}
                    onClick={() => handleNestedSubMenu(i)}
                    aria-haspopup="true"
                  >
                    {child.icon && (
                      <child.icon className="w-5 h-5" aria-hidden="true" />
                    )}
                    <span
                      className="ml-4 mt-1"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {/* {t(`${child.name}`)} */}
                      {child.name}
                    </span>

                    <span className="pr-3">
                      <IoChevronForwardOutline
                        className={`transform transition-transform duration-200 ${
                          subMenuOpen[i] ? "rotate-90" : ""
                        }`}
                      />
                    </span>
                  </button>
                ) : (
                  <NavLink
                    to={child.path || "#"}
                    className="flex items-center font-serif py-2 text-sm text-gray-600 hover:text-green-600 cursor-pointer dark:text-gray-200 px-4"
                    activeClassName="text-green-500 dark:text-gray-100"
                  >
                    <Route path={child.path} exact={child.exact}>
                      <span
                        className="absolute inset-y-0 left-0 w-1 bg-green-600 rounded-tr-lg rounded-br-lg"
                        aria-hidden="true"
                      ></span>
                    </Route>
                    <span className="text-xs text-gray-500 pr-1">
                      {/* <IoRemoveSharp /> */}
                    </span>
                    <span className="text-gray-800 dark:text-gray-300">
                      {/* {t(`${child.name}`)} */}
                      {child.name}
                    </span>
                  </NavLink>
                )}
                <ul className={`${subMenuOpen[i] ? "block" : "hidden"}`}>
                  {child.route &&
                    child.route.length > 0 &&
                    child.route.map((submenu, j) => (
                      <li
                        key={j + 1}
                        className="dark:hover:bg-gray-800 hover:bg-white"
                      >
                        <NavLink
                          to={submenu.path || "#"}
                          className={`flex items-center font-serif py-3 text-sm text-gray-600 hover:text-green-600 cursor-pointer px-4`}
                          activeClassName="text-green-500 dark:text-gray-100"
                        >
                          <Route path={submenu.path} exact={submenu.exact}>
                            <span
                              className="absolute inset-y-0 left-0 w-1 bg-green-600 rounded-tr-lg rounded-br-lg"
                              aria-hidden="true"
                            ></span>
                          </Route>
                          <span className="text-xs text-gray-500 pr-1">
                            {/* <IoRemoveSharp /> */}
                          </span>
                          <span className="text-gray-800 dark:text-gray-300">
                            {/* {t(`${submenu.name}`)} */}
                            {submenu.name.replace(/\b(Day|Hour|Fixed|Airport)\b/g, '').trim()}
                          </span>
                        </NavLink>
                      </li>
                    ))}
                </ul>
              </li>
            ))}
        </ul>
      </li>
    </>
  );
};

export default SidebarSubMenu;
